import App from 'app/app.js';
import 'app/directive/LtPromoZoneCarouselCtrl.js';

function LtPromoZoneCarouselDirective() {
  return {
    restrict: 'E',
    scope: {
      promoZoneCodes: '=',
      hasSlides: '='
    },
    template:
      '<div ng-if="hasSlides" ng-init="ctrl.init()">' +
      '   <div id="carousel-cart-promozone" class="carousel slide related-products most-popular" data-ride="carousel">' +
      '       <ol class="carousel-indicators" >' +
      '           <li ng-repeat="(key, value) in ctrl.promoItems" ng-click="ctrl.pageIndex = key" ng-class="{active: key === ctrl.pageIndex}"></li>' +
      '       </ol>' +
      '       <div class="carousel-inner" role="listbox" ng-repeat="(key, value) in ctrl.promoItems">' +
      '           <div class="item" ng-class="{active: key === ctrl.pageIndex}">' +
      '               <div class="col-xs-12" ng-bind-html="value | ltFormatToHtmlFilter"></div>' +
      '            </div>' +
      '       </div>' +
      '       <a class="left carousel-control" ng-click="ctrl.prevPage()" role="button" data-slide="prev" ng-show="ctrl.hasMultiplePromoItems()">' +
      '           <lt-icon name="fa-sharp-solid-chevron-left" class="fa-chevron-left" aria-hidden="true"></span>' +
      '       </a>' +
      '       <a class="right carousel-control" ng-click="ctrl.nextPage()" role="button" data-slide="next" ng-show="ctrl.hasMultiplePromoItems()">' +
      '           <lt-icon name="fa-sharp-solid-chevron-right" class="fa-chevron-right" aria-hidden="true"></span>' +
      '       </a>' +
      '   </div>' +
      '</div>',
    controller: 'LtPromoZoneCarouselCtrl',
    controllerAs: 'ctrl'
  };
}

App.directive('ltPromoZoneCarousel', [LtPromoZoneCarouselDirective]);
